<template>
    <div class="lesson-box">
        <div
                v-for="(item, index) in goodList"
                :key="index"
                @click="goDetail(item)"
        >
            <el-row class="el-row-out" style="background-color: white">
                <el-col :span="6">
                    <div>
                        <el-image class="lesson-img"
                                  :src="'data:image/'+item.imgType+';base64,'+item.imgSmall">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </div>
                </el-col>
                <el-col :span="18">
                    <el-row :gutter="8" class="el-row-in">
                        <el-col :span="24">
                            <div class="lesson-text-line1"><h5>{{ item.prodName }}</h5></div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col :span="12">
                            <el-tag type="danger" size="small" class="lesson-tag">{{"积分:"+
                                item.price
                                }}
                            </el-tag>
                        </el-col>
                        <el-col :span="12">
                            <el-tag type="danger" size="small" class="lesson-tag">{{"存量:"+
                                item.productStorage.amount
                                }}
                            </el-tag>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <el-row class="last-img"></el-row>
        <!--        <el-image :src="url"></el-image>-->
        <!--        <div class="last-img"></div>-->
    </div>

</template>
<script>
    import {formatDate} from "@api/date.js";

    export default {
        name: "ClassChannelList",
        props: {
            goodList: {
                type: Array,
                default: () => []
            },
            modulePrpty:{
                type: String,
                default: ""
            },
            isSort: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                url: '@assets/images/classChannel/3.jpg'
            };
        },
        methods: {
            // 商品详情跳转
            goDetail(item) {
                console.log("modulePrpty:"+this.modulePrpty);
                this.$router.push({name: 'ProductDetail', params: {product: item,modulePrpty:this.modulePrpty}})
            }
        },
        filters: {
            formatDateDay(time) {
                var date = new Date(time);
                return formatDate(date, "yyyy-MM-dd");
            }
        }
    };
</script>

<style>
    .lesson-text-line1 {
        text-align: left;
        margin-top: 1vh;
        font-size: 12px;
        margin-left: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .lesson-box {
        /*margin-left: 0vw;*/
        /*margin-right: 0vw;*/
        /*margin-top: 1vh;*/
        /*padding: 1px;*/
        margin: 0px;
    }

    .lesson-img {
        margin-top: 1vh;
        margin-left: 1px;
        width: 100%;
        border-radius: 5px;
    }

    .el-row-out {
        /*height: 16.5vh;*/
        margin: 1vh;
        border: 2px solid white;
        border-radius: 8px;
        /*padding: 1vw;*/
    }

    .el-row-in {
        margin-bottom: 5vh;
    }

    .lesson-tag {
        margin-left: 1vw;
        width: 90%;
        border-radius: 30px;
    }

    .last-img {
        height: 20vh;
        width: 100%;
        position: relative;
        text-align: center;
        background-size: 100% 100%; /*按比例缩放*/
        background-image: url("../assets/images/classChannel/3.jpg");
    }
</style>
